/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { footerHolderDetailConfig } from '../../config/footer.config';
export interface IFooterHolderDetailPluginMethods extends IPluginMethodMap {
  getFooterHolderDetailSync(args?: any): any;
}

export class FooterHolderDetailPlugin implements IAgentPlugin {
  readonly methods: IFooterHolderDetailPluginMethods;

  constructor() {
    this.methods = {
      getFooterHolderDetailSync: this.getFooterHolderDetailSync.bind(this),
    };
  }

  getFooterHolderDetailSync(args?: any) {
    return {
      footer: footerHolderDetailConfig,
    };
  }
}
